/** Wordmark uses Nunito ExtraBold — same family as marketing body, avoids Avenir/Poppins metric glitches. */
export const MIVO_WORDMARK_FONT_FAMILY = '"Nunito", sans-serif';

export const MIVO_WORDMARK_PEACH = "#E7A386";

/** Dotless i keeps a full-height stem; the peach tittle is drawn separately. */
export const MIVO_WORDMARK_DOTLESS_I = "\u0131";

export function mivoWordMarkRootStyle(fontSize: string) {
  return {
    fontSize,
    fontWeight: 800,
    fontFamily: MIVO_WORDMARK_FONT_FAMILY,
    display: "inline-flex" as const,
    alignItems: "baseline" as const,
    lineHeight: 1,
    fontKerning: "none" as const,
    fontVariantLigatures: "none" as const,
    fontSynthesis: "none" as const,
    WebkitFontSmoothing: "auto" as const,
    MozOsxFontSmoothing: "auto" as const,
  };
}

export function mivoWordMarkPeachDotStyle() {
  return {
    position: "absolute" as const,
    left: "50%",
    width: "0.2em",
    height: "0.2em",
    borderRadius: "50%",
    backgroundColor: MIVO_WORDMARK_PEACH,
    transform: "translateX(-50%)",
    pointerEvents: "none" as const,
  };
}
